module.exports = __webpack_public_path__ + "img/step3.08ad6797.png";